module.exports = __webpack_public_path__ + "img/planner-filter.8d0a2e3d.svg";